export default { sha: '2e83d9446b59d53bf0c36c03a88f5256d9dc1b6a', buildNumber: 'undefined' }
